import SingleSelectDropdown from "./SingleSelectDropdown";
import TextFieldLabel from "./TextFieldLabel";

export default function SingleSelectDropdownFieldWithLabel({
  label,
  initialPosition = "top",
  ...inputProps
}) {
  const isLeft = initialPosition === "left";
  const containerClass = `flex ${isLeft ? "flex-row" : "flex-col"} gap-1`;
  return (
    <div className={containerClass}>
      <TextFieldLabel label={label} />
      <SingleSelectDropdown {...inputProps} />
    </div>
  );
}
